module.exports = __webpack_public_path__ + "img/imag5.0611ab85.png";